<template>
  <v-layout>
    <v-flex shrink>
      <v-card
        width="250px"
        class="elevation-5"
        v-if="Object.keys(permission.main_menu).length > 0"
        style="border-radius: 16px"
      >
        <v-list class="py-0" style="background-color: #000">
          <v-list-tile>
            <v-list-tile-title
              style="text-align: center; font-size: 20px; color: white"
              >MAIN MENU
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
        <v-list dark class="py-0" style="background-color: #424242">
          <v-list-tile
            v-for="item in filteredSidebar"
            :key="item.title"
            :to="item.link"
          >
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content class="white--text">
              {{ item.title }}
            </v-list-tile-content>
          </v-list-tile>
          <v-list-group
            v-for="item in filteredGroupSidebar"
            v-model="item.active"
            :key="item.title"
            :prepend-icon="item.action"
            no-action
          >
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <div>
                  {{ item.title }}
                </div>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile
              v-for="subItem in filteredSubGroupSidebar(item)"
              :key="subItem.title"
              :to="subItem.link"
            >
              <v-list-tile-content>
                <div>
                  {{ subItem.title }}
                </div>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>
        </v-list>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from "vuex";
import appConfigFeatureService from "@/services/appConfigFeatureService";
export default {
  data() {
    return {
      menuItems: [
        {
          icon: "directions_bike",
          title: "Rider Tracker",
          permission_name: "tracking_rider",
          feature_name: "rider_tracker",
          link: "/weserve_admin_login/tracking/-/rider-tracker",
        },

        {
          icon: "perm_device_information",
          title: "Find USER OTP",
          permission_name: "find_user_otp",
          link: "/weserve_admin_login/-/find_user_otp",
        },
        {
          icon: "assessment",
          title: "Report Dashboard",
          permission_name: "report_dashboard",
          link: "/weserve_admin_login/-/reportdashboard/main",
        },
        // {
        //   icon: "mdi-domain",
        //   title: "Hotel Service",
        //   permission_name: "hotel_service",
        //   link: "/weserve_admin_login/-/hotel-services/hotel-list",
        // },
        // {
        //   icon: "mdi-briefcase-variant",
        //   title: "Weserve for Business",
        //   permission_name: "dine_in_management",
        //   link: "/weserve_admin_login/-/business/table",
        // },
        // {
        //   icon: "token",
        //   title: "Transfer Token",
        //   permission_name: "transfer_token_queue",
        //   link: "/weserve_admin_login/-/transfer-token-queue",
        // },
      ],
      listGroup: [
        {
          action: "hub",
          title: "SERVICE",
          permission_name: [
            "dine_in_management",
            "merchant_manage",
            "messenger.contract",
          ],
          items: [
            {
              icon: "store",
              title: "Merchant Management",
              permission_name: "merchant_manage",
              link: "/weserve_admin_login/-/mainmerchant/contactstoreapprove",
            },
            {
              icon: "dining",
              title: "Dine-in Management",
              permission_name: "dine_in_management",
              link: "/weserve_admin_login/-/maindinein",
            },
            {
              icon: "assignment",
              title: "สัญญา Messenger B2B",
              permission_name: "messenger.contract",
              link: "/weserve_admin_login/-/messenger/contracts",
            },
          ],
        },
        {
          action: "group",
          title: "USER",
          permission_name: [
            "customer_manage",
            "manage_staff",
            "manager_manage",
            "messenger.contract",
          ],
          items: [
            {
              title: "Customer",
              permission_name: "customer_manage",
              link: "/weserve_admin_login/-/customermanage",
            },
            {
              title: "Staff",
              permission_name: "manage_staff",
              link: "/weserve_admin_login/-/usermanage",
            },
            {
              title: "Manager Management",
              permission_name: "manager_manage",
              link: "/weserve_admin_login/-/manager-manage",
            },
            {
              icon: "business",
              title: "Company Users",
              permission_name: "messenger.contract",
              role_names: ["SuperAdmin", "Root"],
              link: "/weserve_admin_login/-/company-management",
            },
          ],
        },
        {
          action: "redeem",
          title: "CRM",
          permission_name: [
            "app_campaign_reward",
            "campaign_crypto",
            "point_manage",
            "promotion_manage",
          ],
          items: [
            {
              title: "Campaign Reward",
              permission_name: "app_campaign_reward",
              link: "/weserve_admin_login/-/campaign/appcampaignreward",
            },
            {
              title: "Campaign Crypto",
              permission_name: "campaign_crypto",
              link: "/weserve_admin_login/-/campaign/campaign-crypto",
            },
            {
              title: "Point Management",
              permission_name: "point_manage",
              link: "/weserve_admin_login/-/pointmanage",
            },
            {
              title: "Promotion",
              permission_name: "promotion_manage",
              link: "/weserve_admin_login/-/promotion-manage",
            },
          ],
        },
        {
          action: "build",
          title: "WESERVE APP",
          permission_name: [
            "app_maintance",
            "app_notificaition",
            "service_manage",
            "tier_benefits_manage",
            "weserve_ads",
          ],
          items: [
            {
              icon: "build",
              title: "App Maintenance",
              permission_name: "app_maintance",
              link: "/weserve_admin_login/-/set_maintenance",
            },
            {
              icon: "notifications_active",
              title: "App Notification",
              permission_name: "app_notificaition",
              link: "/weserve_admin_login/-/appnotification",
            },
            {
              icon: "room_service",
              title: "Service Management",
              permission_name: "service_manage",
              link: "/weserve_admin_login/-/servicemanage",
            },
            {
              icon: "outlined_flag",
              title: "Tier Benefits",
              permission_name: "tier_benefits_manage",
              link: "/weserve_admin_login/-/tierbenefitsmanage",
            },
            {
              icon: "mdi-advertisements",
              title: "WESERVE ADS",
              permission_name: "weserve_ads",
              link: "/weserve_admin_login/weserve-ads",
            },
          ],
        },
        {
          action: "trending_up",
          title: "FINANCIAL",
          permission_name: [
            "rider_request_cash",
            "weserve_card_payment_refund",
            "messenger.contract",
          ],
          items: [
            {
              icon: "account_balance_wallet",
              title: "เครดิตบริษัท",
              permission_name: "messenger.contract",
              role_names: [
                "Accounting",
                "Accountant",
                "Callcenter",
                "CallCenterAdmin",
                "SuperAdmin",
                "Root",
              ],
              link: "/weserve_admin_login/-/messenger/company-credit",
            },
            {
              icon: "monetization_on",
              title: "Order Incentive",
              permission_name: "messenger.contract",
              role_names: ["Accounting", "SuperAdmin", "Root"],
              link: "/weserve_admin_login/order-incentive",
            },
            {
              icon: "",
              title: "Rider Request Cash",
              permission_name: "rider_request_cash",
              link: "/weserve_admin_login/rider_request_cash",
            },
            {
              icon: "",
              title: "Card Payment Refund",
              permission_name: "weserve_card_payment_refund",
              link: "/weserve_admin_login/weserve-card-refund",
            },
            {
              icon: "",
              title: "Store Income",
              permission_name: "transfer_merchant_credit",
              link: "/weserve_admin_login/transfer-merchant-credit",
            },
          ],
        },
      ],
    };
  },
  computed: {
    ...mapState({
      selectedMenu: (state) => state.backOffice.selectedMenu,
      permission: (state) => state.permission,
      role: (state) => state.role,
    }),
    // menu items that are simple links (no sub-items)
    filteredSidebar() {
      return this.menuItems.filter((val) => {
        // ignore entries that are groups (have `.items`)
        if (val.items && Array.isArray(val.items)) return false;
        return (
          this.hasPermission(val.permission_name) &&
          this.hasFeatureEnabled(val.feature_name)
        );
      });
    },
    // group menus can come either from `menuItems` (preferred) or from the
    // legacy `listGroup`. This computed returns groups that have at least one
    // permitted sub-item.
    filteredGroupSidebar() {
      // first, collect groups defined inside menuItems
      const groupsFromMenu = this.menuItems
        .filter((v) => v.items && Array.isArray(v.items))
        .filter((group) => {
          // group-level permission may be string or array, but we still require
          // at least one permitted sub-item to render the group
          const hasAnySub = group.items.some((sub) =>
            this.hasPermission(sub.permission_name) &&
            this.hasAllowedRole(sub.role_names) &&
            this.hasFeatureEnabled(sub.feature_name)
          );
          if (!hasAnySub) return false;
          // If group has its own permission_name, ensure at least one of the
          // group perms is allowed as well.
          if (group.permission_name)
            return this.hasPermission(group.permission_name);
          return true;
        });

      if (groupsFromMenu.length) return groupsFromMenu;

      // fallback to legacy listGroup (permission_name is an array there)
      return this.listGroup.filter((val) => {
        if (!val.permission_name) return false;
        if (Array.isArray(val.permission_name)) {
          return this.hasPermission(val.permission_name);
        }
        return this.hasPermission(val.permission_name);
      });
    },
  },
  methods: {
    // supports permission_name as string or array
    hasPermission(permissionName) {
      if (!permissionName) return false;
      if (Array.isArray(permissionName)) {
        return permissionName.some((p) => this.hasPermission(p));
      }
      if (permissionName.includes(".")) {
        const permissionPath = permissionName.split(".");
        const permissionGroup = this.permission[permissionPath[0]] || {};
        return permissionPath[1] in permissionGroup;
      }
      return permissionName in this.permission.main_menu;
    },
    hasFeatureEnabled(featureName) {
      if (!featureName) return true;
      return appConfigFeatureService.isFeatureEnabled(featureName, {
        defaultValue: true,
      });
    },

    filteredSubGroupSidebar(item) {
      if (!item || !item.items) return [];
      return item.items.filter((subItem) =>
        this.hasPermission(subItem.permission_name) &&
        this.hasAllowedRole(subItem.role_names) &&
        this.hasFeatureEnabled(subItem.feature_name)
      );
    },
    hasAllowedRole(roleNames) {
      if (!roleNames || !roleNames.length) return true;
      const currentRole = String(this.role || "")
        .toLowerCase()
        .replace(/[^a-z0-9]/g, "");
      return roleNames.some(
        (role) =>
          String(role)
            .toLowerCase()
            .replace(/[^a-z0-9]/g, "") === currentRole
      );
    },
  },
};
</script>
